@if (brand == 'prixtel') {
  <app-vitrine-menu></app-vitrine-menu>
}
@if (brand == 'coriolis') {
  <app-vitrine-menu-coriolis></app-vitrine-menu-coriolis>
}

<div [id]="'wrapper-' + brand" class="wpx_wrap">
  @if (brand == 'lacarte') {
    <a href="{{ vitrineUrl }}" class="logo"></a>
  }
  <app-breadcrumb [breadcrumb]="breadcrumbDetails" [brand]="brand"></app-breadcrumb>
</div>

<div [id]="'login-form-' + brand" class="row form_container">
  <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
    <div class="card card-signin my-5">
      <div class="card-body">
        <h1 class="card-title text-center blue-color">Mot de passe oublié</h1>
        Saisissez l'e-mail associé à votre compte.
        <br/>
        Nous allons vous envoyer un lien pour réinitialiser votre mot de passe.
        <br/><br/>
        <form class="form text-center" [formGroup]="forgotPasswordForm" (ngSubmit)="send()">
          <div class="form-group">
            <label for="inputEmail" class="bold-label-text float-left">Votre numéro de téléphone ou e-mail*</label>
            <input type="text" id="inputEmail" class="form-control" placeholder="Entrez votre numéro de téléphone ou e-mail" formControlName="login" required>
            @if (forgotPasswordFormSubmitted && forgotPasswordForm.controls.login.errors) {
              <p class="error-message">Veuillez entrer une adresse email valide.</p>
            }
          </div>
          @if (multipleAccount) {
            <div class="form-group">
              <label for="phoneNumber" class="bold-label-text float-left">Votre numéro de téléphone*</label>
              <input type="text" id="phoneNumber" class="form-control" placeholder="Entrez votre numéro de téléphone" formControlName="phoneNumber">
              @if (forgotPasswordFormSubmitted && forgotPasswordForm.controls.phoneNumber.errors) {
                <p class="error-message">Ce numéro de téléphone n'est pas valide.</p>
              }
            </div>
          }
          <div class="bloc_cta">
            <button type="submit" class="cta_btn level_2">Réinitialiser le mot de passe<span></span></button>
            <button class="cta_cancel" (click)="backToLoginPage()">Annuler<span></span></button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

  @if (brand == 'prixtel') {
    <app-vitrine-footer></app-vitrine-footer>
  }
  @if (brand == 'coriolis') {
    <app-vitrine-footer-coriolis></app-vitrine-footer-coriolis>
  }
